export default __webpack_public_path__ + "static/media/OpenSeaIcon.722c5955.svg";